import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Button } from 'antd';
import { typeMap } from '../../constData';

class ButtonGroup extends Component {
	// 保存数据
	handleSave = () => {
		const { onclickSave } = this.props;
		onclickSave && onclickSave()
	}

	// 处理返工
	handleReword = () => {
		const { onClickReword } = this.props;
		onClickReword && onClickReword()
	}

	// 处理通过
	handlePass = () => {
		const { onClickPass } = this.props;
		onClickPass && onClickPass()
	}

	// 下一题
	nextTitle = () => {
		const { onClickNextBtn } = this.props;
		onClickNextBtn && onClickNextBtn()
	}

	render () {
		const { type, buttonPower } = this.props;
		const { questionSign, questionSignCheckPass, questionSignRework, questionSignModify, questionIcon, questionIconCheckPass, questionIconRework, questionIconModify, questionCheckPass, questionRework} = buttonPower;
		// type - 10标记中,20标记审核中,21标记返工,22待插画(标记审核通过),30插画中,40插画审核中,41插画返工,42题目待审核,50题目审核中,60订正
		// 是否显示-保存-按钮
		let isShowSaveBtn = (type === typeMap.signing && !!questionSign) || (type === typeMap.sign_rework && !!questionSignModify) || (type === typeMap.icon_ing && !!questionIcon) || (type === typeMap.icon_rework && !!questionIconModify);
		// 是否显示-返工-按钮
		let isShowRewordBth = (type === typeMap.sign_checking && !!questionSignRework) || (type === typeMap.icon_checking && !!questionIconRework) || (type === typeMap.checking && !!questionRework);
		// 是否显示-通过-按钮
		let isShowPassBtn = (type === typeMap.sign_checking && !!questionSignCheckPass) || (type === typeMap.icon_checking && !!questionIconCheckPass) || (type === typeMap.checking && !!questionCheckPass)
		// 是否显示-下一题-按钮
		let isShowNextBtn = (type === typeMap.checking)
		return (
			<div className="groupButton">
				{
					isShowNextBtn && <Button type="primary" onClick={this.nextTitle}>下一题</Button>
				}
				{
					isShowSaveBtn && <Button type="primary" onClick={this.handleSave}>保存</Button>
				}
				{
					isShowRewordBth && <Button type="primary" onClick={this.handleReword}>返工</Button>
				}
				{
					isShowPassBtn && <Button type="primary" onClick={this.handlePass}>通过</Button>
				}
								
			</div>
		)
	}
}

export default ButtonGroup;


// WEBPACK FOOTER //
// ./src/entry_app/question_manage/image_correction/image_correction_detail/common/buttonGroup.js